const schemaFieldName = {
  // NOTE: Date values have to be transformed into their 'ISO' format.
  // NOTE: 'true', 'false' values need to be transformed into 'boolean'.
  policyType: 'policyType', // Only used internally.
  policyNumber: 'policyNumber',

  alternativeClaimOption: {
    otherClaimSource: 'alternativeClaimOption_otherClaimSource',
    otherClaimDescription: 'alternativeClaimOption_otherClaimDescription',
  },

  tripDetails: {
    // NOTE: 'tripType needs to be derived from 'policyType'.
    tripType: 'tripDetails_tripType',
    travellersType: 'tripDetails_travellersType', // Only used internally.
    annualMultiTripDetails: {
      travelEndDate: 'tripDetails_annualMultiTripDetails_travelEndDate',
      travelStartDate: 'tripDetails_annualMultiTripDetails_travelStartDate',
      firstPaymentDate: 'tripDetails_annualMultiTripDetails_firstPaymentDate',
    },
    impactedTravellers: {
      // NOTE: 'listedTravellers' needs to be transformed into an array.
      listedTravellers: 'tripDetails_impactedTravellers_listedTravellers',
      // NOTE: 'unlistedTravellers' needs to be transformed into an array.
      unlistedTravellers: {
        lastName: 'tripDetails_impactedTravellers_unlistedTravellers_0_lastName',
        firstName: 'tripDetails_impactedTravellers_unlistedTravellers_0_firstName',
        relationshipToPolicyHolder:
          'tripDetails_impactedTravellers_unlistedTravellers_0_relationshipToPolicyHolder',
      },
    },
  },

  incident: {
    // NOTE: 'incidentDate', 'incidentTime' need to be transformed into a single field.
    incidentCountry: 'incident_incidentCountry',
    incidentCity: 'incident_incidentCity',
    incidentDate: 'incident_incidentDate',
    incidentTime: 'incident_incidentTime',
    incidentTiming: 'incident_incidentTiming',
    incidentDescription: 'incident_incidentDescription',
    mainCause: 'incident_mainCause',
    injuryDetails: {
      injuryType: 'incident_injuryDetails_injuryType',
      injuryCause: 'incident_injuryDetails_injuryCause',
      vehicleSpecificInjuryDetails: {
        vehicleType: 'incident_injuryDetails_vehicleSpecificInjuryDetails_vehicleType',
        motorcycleMopedEngineCapacityCC:
          'incident_injuryDetails_vehicleSpecificInjuryDetails_motorcycleMopedEngineCapacityCC',
        personalInvolvement:
          'incident_injuryDetails_vehicleSpecificInjuryDetails_personalInvolvement',
        multiplePeopleInvolved:
          'incident_injuryDetails_vehicleSpecificInjuryDetails_multiplePeopleInvolved',
        // NOTE: 'otherInvolvedPersons' needs to be transformed into an array.
        otherInvolvedPersons: {
          firstName:
            'incident_injuryDetails_vehicleSpecificInjuryDetails_otherInvolvedPersons_0_firstName',
          lastName:
            'incident_injuryDetails_vehicleSpecificInjuryDetails_otherInvolvedPersons_0_lastName',
        },
      },
      snowSportsSpecificInjuryDetails: {
        activityOffPiste: 'incident_injuryDetails_snowSportsSpecificInjuryDetails_activityOffPiste',
      },
      adventureActivitySpecificInjuryDetails: {
        activityType: 'incident_injuryDetails_adventureActivitySpecificInjuryDetails_activityType',
      },
      accidentalFallSpecificInjuryDetails: {
        incidentLocation:
          'incident_injuryDetails_accidentalFallSpecificInjuryDetails_incidentLocation',
      },
    },
    illnessDetails: {
      medicalCondition: 'incident_illnessDetails_medicalCondition',
    },
    dentalDetails: {
      treatmentType: 'incident_dentalDetails_treatmentType',
    },
    emergencyAssistanceDetails: {
      emergencyAssistanceContacted:
        'incident_emergencyAssistanceDetails_emergencyAssistanceContacted',
      callReferenceNumber: 'incident_emergencyAssistanceDetails_callReferenceNumber',
    },
    hospitalisationDetails: {
      hospitalAdmissionRequired: 'incident_hospitalisationDetails_hospitalAdmissionRequired',
      hospitalName: 'incident_hospitalisationDetails_hospitalName',
      // NOTE: 'admissionDate',  'admissionTime, need to be transformed into a single field.
      admissionDate: 'incident_hospitalisationDetails_admissionDate',
      admissionTime: 'incident_hospitalisationDetails_admissionTime',
      // NOTE: 'dischargeDate',  'dischargeTime, need to be transformed into a single field.
      dischargeDate: 'incident_hospitalisationDetails_dischargeDate',
      dischargeTime: 'incident_hospitalisationDetails_dischargeTime',
    },
  },

  expenses: {
    // NOTE: 'medicalExpenses' needs to be transformed into a repeatable array.
    medicalExpenseIds: 'expenses_medicalExpenseIds', // Only used internally.
    hasMedicalExpense: 'expenses_hasMedicalExpense', // Only used internally.
    medicalExpenses: {
      expenseId: 'expenses_medicalExpenses_{i}_expenseId',
      expenseType: 'expenses_medicalExpenses_{i}_expenseType',
      expenseDate: 'expenses_medicalExpenses_{i}_expenseDate',
      expensePaidInFull: 'expenses_medicalExpenses_{i}_expensePaidInFull',
      expenseAmount: {
        amount: 'expenses_medicalExpenses_{i}_expenseAmount_amount',
        currencyCode: 'expenses_medicalExpenses_{i}_expenseAmount_currencyCode',
      },
      claimAmount: {
        amount: 'expenses_medicalExpenses_{i}_claimAmount_amount',
        currencyCode: 'expenses_medicalExpenses_{i}_claimAmount_currencyCode',
      },
      providerOwedAmount: {
        amount: 'expenses_medicalExpenses_{i}_providerOwedAmount_amount',
        currencyCode: 'expenses_medicalExpenses_{i}_providerOwedAmount_currencyCode',
      },
      providerDetails: {
        swiftCode: 'expenses_medicalExpenses_{i}_providerDetails_swiftCode', // Only used internally.
        ibanNumber: 'expenses_medicalExpenses_{i}_providerDetails_ibanNumber', // Only used internally.
        // NOTE: 'accountType' is derived from 'swiftCode' and 'ibanNumber'.
        accountType: 'expenses_medicalExpenses_{i}_providerDetails_accountType',
        accountName: 'expenses_medicalExpenses_{i}_providerDetails_accountName',
        // NOTE: 'accountNumber' is derived from 'swiftCode' and 'ibanNumber'.
        accountNumber: 'expenses_medicalExpenses_{i}_providerDetails_accountNumber',
        referenceNumber: 'expenses_medicalExpenses_{i}_providerDetails_referenceNumber',
      },
    },

    // NOTE: 'cancellationExpenses' needs to be transformed into a repeatable array.
    cancellationExpenseIds: 'expenses_cancellationExpenseIds', // Only used internally.
    hasCancellationExpense: 'expenses_hasCancellationExpense', // Only used internally.
    cancellationExpenses: {
      expenseId: 'expenses_cancellationExpenses_{i}_expenseId',
      expenseType: 'expenses_cancellationExpenses_{i}_expenseType',
      expenseDate: 'expenses_cancellationExpenses_{i}_expenseDate',
      expenseDescription: 'expenses_cancellationExpenses_{i}_expenseDescription',
      expenseAmount: {
        amount: 'expenses_cancellationExpenses_{i}_expenseAmount_amount',
        currencyCode: 'expenses_cancellationExpenses_{i}_expenseAmount_currencyCode',
      },
      claimAmount: {
        amount: 'expenses_cancellationExpenses_{i}_claimAmount_amount',
        currencyCode: 'expenses_cancellationExpenses_{i}_claimAmount_currencyCode',
      },
      creditNoteOrRefundReceived: 'expenses_cancellationExpenses_{i}_creditNoteOrRefundReceived',
      creditNoteOrRefundAmount: {
        amount: 'expenses_cancellationExpenses_{i}_creditNoteOrRefundAmount_amount',
        currencyCode: 'expenses_cancellationExpenses_{i}_creditNoteOrRefundAmount_currencyCode',
      },
    },

    // NOTE: 'additionalExpenses' needs to be transformed into a repeatable array.
    additionalExpenseIds: 'expenses_additionalExpenseIds', // Only used internally.
    hasAdditionalExpense: 'expenses_hasAdditionalExpense', // Only used internally.
    additionalExpenses: {
      expenseId: 'expenses_additionalExpenses_{i}_expenseId',
      expenseType: 'expenses_additionalExpenses_{i}_expenseType',
      expenseDate: 'expenses_additionalExpenses_{i}_expenseDate',
      expenseDescription: 'expenses_additionalExpenses_{i}_expenseDescription',
      expenseAmount: {
        amount: 'expenses_additionalExpenses_{i}_expenseAmount_amount',
        currencyCode: 'expenses_additionalExpenses_{i}_expenseAmount_currencyCode',
      },
      claimAmount: {
        amount: 'expenses_additionalExpenses_{i}_claimAmount_amount',
        currencyCode: 'expenses_additionalExpenses_{i}_claimAmount_currencyCode',
      },
      creditNoteOrRefundReceived: 'expenses_additionalExpenses_{i}_creditNoteOrRefundReceived',
      creditNoteOrRefundAmount: {
        amount: 'expenses_additionalExpenses_{i}_creditNoteOrRefundAmount_amount',
        currencyCode: 'expenses_additionalExpenses_{i}_creditNoteOrRefundAmount_currencyCode',
      },
    },
  },

  paymentDetails: {
    bsb: 'paymentDetails_bsb',
    accountName: 'paymentDetails_accountName',
    accountNumber: 'paymentDetails_accountNumber',
    inputTaxCreditEntitlement: 'paymentDetails_inputTaxCreditEntitlement',
    gstPercent: 'paymentDetails_gstPercent',
    abn: 'paymentDetails_abn',
  },

  notifications: {
    emailAddress: 'notifications_emailAddress',
    mobileNumber: 'notifications_mobileNumber',
    // NOTE: Providing 'mobileNumber' sets 'preferredContactMethod' to 'phone'.
    preferredContactMethod: 'notifications_preferredContactMethod',
    // NOTE: Providing 'mobileNumber' sets 'receiveClaimNotifications' to 'true'.
    receiveClaimNotifications: 'notifications_receiveClaimNotifications',
  },

  documentInstructions: 'documentInstructions',
} as const;

export { schemaFieldName };
